namespace Ir.Components.Workbook.Settings.WorkbookTabsPopover {
    export interface IWorkbookTabsPopoverParams {
        callback(o: IWorkbookTabsPopover);
        position?: DevExpress.PositionConfig;
    }

    export interface IWorkbookTabsPopover {
        show($target, onSelect: (id: number) => void, title?: string);
    }

    interface IViewModel {
        popoverConfig: DevExpress.ui.dxPopover.Properties;
        popoverComponent: DevExpress.ui.dxPopover;
        listConfig: DevExpress.ui.dxList.Properties;
        listComponent: DevExpress.ui.dxList;
    }

    interface IParams {
        config: IWorkbookTabsPopoverParams;
    }

    class ItemTabMoveCopyViewModel {
        initialTabId: number;
        id: number;
        initialName: string;
        name: string;
        order: number;
        icon: string;
        iconClass: string;
        hiddenTab: boolean;
        clone: boolean;
        tabConfig: WorkbookTabConfig;
        isDefaultTab: boolean;

        constructor(data) {
            this.id = data.id;
            this.initialTabId = data.initialTabId || this.id;
            this.name = data.name;
            this.order = data.order;
            this.icon = data.icon;
            this.iconClass = data.iconClass;
            this.hiddenTab = data.hiddenTab;
            this.initialName = data.initialName || this.name;
            this.clone = data.clone || false;
            this.tabConfig = data.tabConfig;
            this.isDefaultTab = data.isDefaultTab || false;
        }
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;

        let onSelectTab: (id: number) => void;

        self.listConfig = {
            keyExpr: 'id',
            displayExpr: 'name',
            searchEnabled: true,
            searchExpr: 'name',
            pageLoadMode: 'scrollBottom',
            itemTemplate: template,
            useNativeScrolling: false,
            onInitialized: function (e) {
                self.listComponent = e.component;
            },
            onItemClick: function (e) {
                onSelectTab(e.itemData.id);
                self.popoverComponent.hide();
            },
        };

        self.popoverConfig = {
            title: "Tab selection",
            showTitle: true,
            position: params.config.position ? params.config.position : "right",
            width: 300,
            height: 400,
            visible: false,
            onShowing(e) {
                let dataSource = workbook.workbookConfig.workbookHelper.workbookTabsDataSource().filter(x => x.tab().tabType() !== TabTypeEnum.Dashboard).map((x) => {
                    return new ItemTabMoveCopyViewModel({
                        id: x.tabId,
                        name: x.tab().name(),
                        order: x.tab().order(),
                        icon: x.tab().icon(),
                        iconClass: x.iconClass,
                        hiddenTab: x.tab().tabConfig.hiddenTab(),
                        clone: false,
                        tabConfig: x.tab().tabConfig,
                        isDefaultTab: x.tab().isDefaultTab()
                    })
                });
                self.listComponent.option("dataSource", dataSource);
            },
            onInitialized: function (e) {
                self.popoverComponent = e.component;
                if (params.config.callback && typeof params.config.callback === "function") {
                    params.config.callback({
                        show($target, onSelect: (item) => void, title: string = null) {
                            onSelectTab = onSelect;
                            let titlePopover = "Tab Selection";
                            if (title) {
                                titlePopover = title;
                            }
                            self.popoverComponent.option("title", titlePopover);
                            self.popoverComponent.show($target);
                        }
                    } as IWorkbookTabsPopover);
                }
            },
        };
    }

    function template(itemData, itemIndex, abc) {
        let itemElement = $(`<div data-bind="style: { backgroundColor: $data.item.tabConfig.backgroundColor() }">`);

        let $defaultTab = $(`<i class="ms" style="color: #ffc107;" data-bind="visible: $data.item.isDefaultTab">star</i>`);
        itemElement.append($defaultTab);

        let $icon = $('<i data-bind="style: { color: $data.item.tabConfig.fontColor() }">').text(itemData.icon);
        if (itemData.iconClass) {
            $icon.addClass(itemData.iconClass);
        }
        else {
            $icon.addClass("ms");
        }
        itemElement.append($icon);

        let $span = $(`<span data-bind="text: $data.item.name,style: { color: $data.item.tabConfig.fontColor() }"></span>`)
        itemElement.append($span);

        if (itemData.hiddenTab) {
            let $eyeIcon = $(`<i class="ms" style="padding-left: 4px" data-bind="style: { color: $data.item.tabConfig.fontColor() }">visibility_off</i>`);
            itemElement.append($eyeIcon);
        }

        ko.applyBindings({
            item: itemData,
        }, itemElement.get(0))

        return itemElement;
    }
}